var _path;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgRightQuote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 27,
    viewBox: "0 0 30 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.944 24.832C2.00533 24.832 1.28 24.5547 0.768 24C0.256 23.4453 0 22.6987 0 21.76C0 20.736 0.192 19.6693 0.576 18.56C1.00267 17.4507 1.49333 16.256 2.048 14.976C2.60267 13.6533 3.11467 12.2027 3.584 10.624C4.096 9.00267 4.416 7.232 4.544 5.312C4.672 3.52 5.07733 2.19733 5.76 1.344C6.44267 0.447999 7.44533 0 8.768 0C10.2187 0 11.4347 0.447999 12.416 1.344C13.3973 2.24 13.888 3.41333 13.888 4.864C13.888 6.31467 13.7173 7.85067 13.376 9.472C13.0347 11.0507 12.5653 12.6293 11.968 14.208C11.3707 15.744 10.688 17.216 9.92 18.624C9.152 19.9893 8.36267 21.184 7.552 22.208C6.784 23.0613 6.03733 23.7227 5.312 24.192C4.62933 24.6187 3.84 24.832 2.944 24.832ZM20.544 26.816C19.52 26.816 18.7307 26.5813 18.176 26.112C17.664 25.6 17.408 24.896 17.408 24C17.408 23.1467 17.5573 22.2933 17.856 21.44C18.1973 20.5867 18.5813 19.6693 19.008 18.688C19.4773 17.664 19.904 16.4907 20.288 15.168C20.7147 13.8453 21.0133 12.3307 21.184 10.624C21.3973 8.704 21.824 7.44533 22.464 6.848C23.104 6.208 23.936 5.888 24.96 5.888C26.4533 5.888 27.648 6.31467 28.544 7.168C29.44 7.97867 29.888 9.19467 29.888 10.816C29.888 12.6933 29.5467 14.784 28.864 17.088C28.224 19.3493 27.0933 21.568 25.472 23.744C24.704 24.768 23.936 25.536 23.168 26.048C22.4 26.56 21.5253 26.816 20.544 26.816Z",
    fill: "#9747FF"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightQuote);
export default __webpack_public_path__ + "static/media/right_quote.d64d681e.svg";
export { ForwardRef as ReactComponent };